;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { PropsWithChildren } from "react"

export default function RightSideContainer({ children }: PropsWithChildren) {
  return (
    <div className="max-w-[600px] min-[800px]:max-w-none w-full min-[1100px]:w-[34%] h-full bg-white flex items-start justify-center rounded-[0_0_20px_20px] min-[1100px]:rounded-[0_20px_20px_0]">
      <div className="px-[10px] min-[600px]:px-[20px] grow">{children}</div>
    </div>
  )
}
